document.addEventListener("DOMContentLoaded", function () {
  /*
  * Function to clear selected variations on a variable product  
  **/
  document.addEventListener('click', function (event) {
    //on click...
    if (!event.target.matches('.reset_variations')) return; //if it's not the reset_variations link, bail

    event.preventDefault();
    var variationRadios = document.querySelectorAll('.variation-radio-wrapper input[type="radio"]'); //get the custom radio inputs

    var variationLabels = document.querySelectorAll('.variation-radio-wrapper label'); //get the custom labels

    var variationRadioWrappers = document.querySelectorAll('.variation-radio-wrapper'),
        i; //one wrapper around each radio input

    var price = document.querySelector('.single_variation_wrap > .price'); //within the grey box - get the first price element

    for (i = 0; i < variationRadioWrappers.length; ++i) {
      //for each radio wrapper...
      variationRadioWrappers[i].classList.remove('selected'); //remove the class that gives it the styled selected view

      variationLabels[i].classList.add('enabled-input');
      variationRadios[i].checked = false; //clear the actual checked radio input
    }

    price.classList.remove('!hidden'); //show the original from: price
  }, false);
}); //if jQuery is loaded (e.g. we're on a Woo page)

if (window.jQuery) {
  jQuery(function ($) {
    $(document).on('change', '.variation-radios input', function () {
      //on change of our custom inputs
      var $el = $(this);
      var thisName = $el.attr('name');
      var thisVal = $el.attr('value');
      $('select[name="' + thisName + '"]').val(thisVal).trigger('change'); //update the select dropdown and trigger the select (runs woocommerce_update_variation_values below)
    });
    $(document).on('woocommerce_update_variation_values', function () {
      $('.variation-radios input').prop('checked', false);
      $('.variation-radio-wrapper').removeClass('selected');
      $('.variations select').each(function (index, element) {
        var $el = $(element);
        var thisVal = $el.val();
        $('input[value = "' + thisVal + '"]').prop('checked', true);
        $('input[value = "' + thisVal + '"]').parent().addClass('selected');
        showActiveRadioInputs();
      });
    }); // recreate radio inputs based on the select inputs

    function showActiveRadioInputs() {
      jQuery('.variation-radios input, .variation-radios label').removeClass('enabled-input');
      jQuery('.variations select').each(function () {
        var inputName = jQuery(this).attr('name');
        jQuery(this).find('option').each(function () {
          var inputVal = jQuery(this).val();
          var radioInput = jQuery('.variation-radios input[value="' + inputVal + '"]');
          jQuery('.variation-radios label[for="' + radioInput.attr('id') + '"]').addClass('enabled-input');
        });
      });
    } // Hide the From: price and show the actual price on variable products


    $(".single_variation_wrap").on("show_variation", function (event, variation) {
      //cannot be made vanilla
      $('.single_variation_wrap > .price').addClass('!hidden');
    }); //Removes the slide effect when you change variation options on a variable product

    $(document).on('show_variation', '.cart.variations_form', function () {
      var hasText = !!$.trim($('.woocommerce-variation.single_variation').text());
      $('.woocommerce-variation.single_variation').stop().removeAttr('style').toggle(hasText);
    }).on('hide_variation', function (e) {
      $('.woocommerce-variation.single_variation').stop().hide();
    });
  });
}